// Ses motoru - sadece mp3 oynatır
export const playCrowdWarning = () => {
  const audio = new Audio("/assets/sounds/crowd-shocked-reaction-352766.mp3");
  audio.volume = 1.0; // sınıfta duyulsun
  audio.play().catch(() => {
    // mobil/autoplay engellemesi durumunda sessiz hata
  });
};

export const playCheer = () => {
  const audio = new Audio("/assets/sounds/cheer.mp3");
  audio.volume = 1.0;
  audio.play().catch(() => {});
};